module.exports = __webpack_public_path__ + "media/images/video/rowhouse-go-logo-fea1d4c01a9a279a11aade4938a29091.png";